import { Injectable } from '@angular/core';

import { User } from '../../models/Core/User';
import { RequestService } from '../request.service';

@Injectable()
export class UsersService {
  api = {
    root: '/users',
  };

  constructor(private client: RequestService) {}

  get(id: string) {
    return this.client.get<User>({
      uri: this.api.root + '/' + id,
    });
  }
}
